import uploadUrls from '../urls/upload'
import jqRequest from '../jqRequest'
import jq from "jquery"
export default {
    // 上传方式 1:默认七牛上传，2：私有云上传
    uploadMethod: 1,
    // 是否终止上传
    terminateUpload: false,
    // 是否分享
    isShare: 1,
    // 分类
    categoryId: 0,
    // 是否转码，1转码，0不转码
    tranFlag: 1,
    // 私有云本地上传
    uploadFileRequest(data, xhr) {
        return jqRequest.requestWithToken2(uploadUrls.uploadFile, data, 'post', '', { cache: false, processData: false, contentType: false }, '', xhr);
    },
    // 私有化上传图片后存储信息
    saveUploadPicture(data) {
        var self = this;
        var valueStr = "title=" + data.fileName;
        valueStr += "&fileName=" + data.fileName;
        valueStr += "&fileSize=" + data.fileSize;
        valueStr += "&height=" + data.height;
        valueStr += "&url=" + data.fileUrl;
        valueStr += "&width=" + data.width;
        valueStr += "&isShare=" + self.isShare;
        valueStr += "&classifyType=" + self.isShare == 1 ? 1 : 2;
        valueStr += "&categoryId=" + self.categoryId;
        return jqRequest.requestWithToken(uploadUrls.saveUploadPicture + "?" + valueStr, null);
    },
    // 私有化上传音视频后的存储信息
    saveUploadStream(data) {
        return jqRequest.requestWithToken2(uploadUrls.saveUploadStream, data, 'post', '', { contentType: 'application/json;charset=UTF-8' }, '', null);
    },
    // 私有化上传音视频后的存储信息
    saveUploadStreamButch(data) {
        return jqRequest.requestWithToken2(uploadUrls.saveUploadStreamButch, data, 'post', '', { contentType: 'application/json;charset=UTF-8' }, '', null);
    },
    // 音视频转码
    transcode(data) {
        return jqRequest.requestWithToken2(uploadUrls.transcode, data, 'post', '', '', { "Content-Type": "application/json" }, null);
    },
    /** 七牛上传。默认视频上传，fileType == 3，按照图片处理 **/
    fetchUpload(fileListItem, url, params, fileType, progressHandler, completeHandler) {
        // tokenParams = {
        // 	source: 2, //PC 1 、手机端 2
        // 	enterpriseCode: process.env.VUE_APP_NODE_CODE, //企业code
        // 	picType: 3, //picType 图片类型	1：内容焦点大图，2：内容列表缩略图，3:管理端上传的其他图片，用于上传后图片压缩剪裁判断-其中1、2 是需要压缩的
        // 	fileName: fileName, //文件名
        // };
        let self = this;

        jqRequest.requestWithToken(url, params).then(res => {
            if (res.suc == 1) {
                /** 七牛规定块写死4M **/
                var perBlockSize = 4 * 1024 * 1024;
                /** 上传块开始位置 **/
                var blockIndex = 0;
                /** 单次上传块不超过4M **/
                var currentBlockSize; // = Math.min( fileListItem.size - blockIndex, perBlockSize );
                /** 所有块创建后返回的ctx字符数组。 **/
                var ctxList = [];


                /** 单次上传片段不超过100K **/
                var perChunkSize = 100 * 1024;
                /** 上传片开始位置 **/
                var chunkIndex = 0;
                /** 当前上传片大小 **/
                var currentChunkSize;

                /** 默认上传host **/
                var tryTime = -1;
                var baseHostList = ["http://up-z1.qiniu.com", "http://up-z2.qiniu.com", "http://up-z2.qiniup.com", "http://up-z0.qiniu.com", "http://upload.qiniu.com", "http://upload-z1.qiniu.com",];
                var baseHost = "";

                /** 创建块，同时上传块中第一个片 **/
                function createBlock(host) {
                    currentBlockSize = Math.min(fileListItem.size - blockIndex, perBlockSize);
                    chunkIndex = 0;
                    currentChunkSize = Math.min(currentBlockSize - chunkIndex, perChunkSize);

                    if (host) baseHost = host;
                    else {
                        ++tryTime;
                        if (tryTime >= baseHostList.length) return;
                        baseHost = baseHostList[tryTime];
                    }
                    jq.ajax({
                        url: baseHost + '/mkblk/' + currentBlockSize,
                        type: 'POST',
                        data: fileListItem.slice(blockIndex + chunkIndex, blockIndex + currentChunkSize),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "application/octet-stream",
                        processData: false,
                        headers: {
                            //"Host": "upload.qiniu.com",
                            "Content-Type": "application/octet-stream",
                            //"Content-Length": currentChunkSize,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (data) {
                            if (progressHandler) {
                                var percentage = parseInt(Number(blockIndex + chunkIndex + currentChunkSize) / Number(fileListItem.size) * 100) + "%";
                                progressHandler(percentage);
                            }

                            /** 记录块级上传ctx **/
                            ctxList.push(data.ctx);

                            /**  片索引自增 **/
                            chunkIndex += currentChunkSize;
                            /**  检查块中的片是否已满，未满，循环上传片 **/
                            if (chunkIndex < currentBlockSize) {
                                /**  循环上传片 **/
                                loopUploadChunk(data);
                                return;
                            }

                            /** 块中片已满，块索引自增 **/
                            blockIndex += currentBlockSize;

                            /** 是否所有块上传完毕 **/
                            if (blockIndex == fileListItem.size) {
                                createFile(data);
                            }
                            /**  全部块上传结束，创建文件 **/
                            else {
                                /** 创建下一个块 **/
                                tryTime = -1;
                                createBlock();
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (tryTime < baseHostList.length) createBlock();
                            else {
                                if (fileType == 3)
                                    console.log("上传图片失败。");
                                else
                                    console.log("上传媒体文件失败。");
                            }
                        }
                    });
                }
                /** 递归上传片段 **/
                function loopUploadChunk(data) {
                    currentChunkSize = Math.min(currentBlockSize - chunkIndex, perChunkSize);
                    jq.ajax({
                        url: data.host + '/bput/' + data.ctx + "/" + chunkIndex,
                        type: 'POST',
                        data: fileListItem.slice(blockIndex + chunkIndex, blockIndex + chunkIndex + currentChunkSize),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "application/octet-stream",
                        processData: false,
                        headers: {
                            //"Host": data.host,
                            "Content-Type": "application/octet-stream",
                            //"Content-Length": currentChunkSize,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (data) {
                            if (progressHandler) {
                                var percentage = parseInt(Number(blockIndex + chunkIndex + currentChunkSize) / Number(fileListItem.size) * 100) + "%";
                                progressHandler(percentage);
                            }
                            /** 更新当前块级上传ctx **/
                            ctxList[ctxList.length - 1] = data.ctx;

                            /**  片索引自增 **/
                            chunkIndex += currentChunkSize;
                            /**  检查块中的片是否已满，未满，循环上传片 **/
                            if (chunkIndex < currentBlockSize) {
                                /**  循环上传片,延迟10毫秒，保证chrome进度条渲染 **/
                                setTimeout(function () {
                                    if (!self.terminateUpload) {
                                        loopUploadChunk(data)
                                    }
                                }, 10);
                                return;
                            }

                            /** 块中片已满，块索引自增 **/
                            blockIndex += currentBlockSize;

                            /** 是否所有块上传完毕 **/
                            if (blockIndex == fileListItem.size) {
                                /**  全部块上传结束，创建文件 **/
                                tryTime = -1;
                                createFile(data);
                            } else {
                                /** 创建下一个块 **/
                                tryTime = -1;
                                createBlock(data.host);
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (fileType == 3)
                                console.log("上传图片失败。");
                            else
                                console.log("上传媒体文件失败。");
                        }
                    });
                }

                /**  全部片段上传结束，创建文件 **/
                function createFile(data) {
                    var host = tryTime < 0 ? data.host : baseHostList[tryTime];
                    jq.ajax({
                        url: host + '/mkfile/' + fileListItem.size,
                        type: 'POST',
                        data: ctxList.toString(),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "text/plain",
                        processData: false,
                        headers: {
                            //"Host": "upload.qiniu.com",
                            "Content-Type": "text/plain",
                            // "Content-Length": ctxList.toString().length,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (finalData) {
                            if (finalData.suc == 1) {
                                if (fileType == 3) {
                                    /** 判断图片压缩是否已完成，如果完成，回调
                                     * 这样做是为了防止，图片压缩后，后台用新的图片替换就图片导致图片路径变化
                                     * isConvert：是否执行图片压缩，不执行，直接回调；执行，等待图片压缩完成后，再回调
                                     * **/
                                    //completeHandler( { resourceId: finalData.data.pictureId, path: finalData.data.accessUrl } );
                                    if (finalData.data.isConvert == true) {
                                        progressHandler("压缩中...");
                                        self.loopImageUploadComplete({
                                            suc: 1,
                                            resourceId: finalData.data.pictureId,
                                            url: finalData.data.accessUrl
                                        }, completeHandler);
                                    } else {
                                        completeHandler({
                                            suc: 1,
                                            resourceId: finalData.data.pictureId,
                                            url: finalData.data.accessUrl
                                        });
                                    }
                                } else {
                                    progressHandler("压缩中...");
                                    self.loopVideoUploadComplete(
                                        {
                                            suc: 1,
                                            resourceId: finalData.data.streamId,
                                            url: '',
                                        },
                                        completeHandler
                                    );
                                }
                            } else {
                                console.log("上传媒体文件失败。\n" + finalData.message);
                                completeHandler({
                                    suc: 0,
                                });
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (++tryTime < baseHostList.length) createFile(data);
                            else {
                                if (fileType == 3)
                                    console.log("上传图片失败。");
                                else
                                    console.log("上传媒体文件失败。");

                                completeHandler({
                                    suc: 0,
                                });
                            }
                        }
                    });
                }
                createBlock();
            } else {
                console.log("获取七牛云上传token失败\n" + res.message);
                completeHandler({
                    suc: 0,
                });
            }
        })
    },
    //压缩图片循环查询
    loopImageUploadComplete(data, callback) {
        let self = this;
        let params = {
            pictureId: data.resourceId,
            t: new Date().getTime()
        };
        let url = uploadUrls.imageCompression;
        setTimeout(function () {
            jqRequest.requestWithToken(url, params).then((res) => {
                if (res.suc == 1 && res.data && res.data.convertStatus == 1) {
                    /** 图片路径更新完毕，回调 **/
                    data.url = res.data.convertAccessUrl;
                    callback(data);
                } else {
                    /** 未完成，递归 **/
                    if (!self.terminateUpload) {
                        self.loopImageUploadComplete(data, callback);
                    }
                }
            });
        }, 1000);
    },
    /** 视频上传七牛后台，递归调用视频详情后台接口，获取视频地址
     * 这么做，是因为后台压缩图片后，会用新图片替换就图片，因而图片路径变更
     * 所以要等待最终图片路径生成后返回图片路径
     * data：{
     *      resourceId: 图片素材id,
     *      path: 图片路径
     * },* callback：页面上注册的上传回调
     * **/
    loopVideoUploadComplete(data, callback) {
        let self = this;
        let params = {
            streamId: data.resourceId,
            t: new Date().getTime(),
        };
        setTimeout(function () {
            var url = uploadUrls.videoCompression;
            jqRequest.requestWithToken(url, params).then((res) => {
                if (res.suc == 1 && res.data && res.data.convertStatus == 1) {
                    /** 压缩完毕，回调 **/
                    data.url = res.data.url;
                    callback(data);
                } else {
                    /** 未完成，递归 **/
                    if (!self.terminateUpload) {
                        self.loopVideoUploadComplete(data, callback);
                    }
                }
            });
        }, 1000);
    },
    // 上传图片
    fetchUploadPic(fileListItem, progressHandler, completeHandler, sync = true) {
        var self = this;
        if (self.uploadMethod == 2) {
            // 私有云上传图片
            // type-上传类型，video：视频，audio:音频，img：图片
            let type = "img";
            let formData = new FormData();
            formData.append('file', fileListItem);
            formData.append('type', type);
            self.singleUploadFile(formData, type, progressHandler, completeHandler, sync);
        } else {
            // 七牛上传图片
            let fileName = fileListItem.name;
            let fileType = 3;
            var tokenParams = {
                source: 2,
                enterpriseCode: process.env.VUE_APP_NODE_CODE,
                picType: 3,
                fileName: fileName,
            };
            let url = uploadUrls.getPicUploadToken + "?datetimeflag=" + new Date().getTime();
            self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
        }
    },
    // 上传视频
    fetchUploadVideo(fileListItem, progressHandler, completeHandler, sync = true) {
        var self = this;
        if (self.uploadMethod == 2) {
            // 私有云上传视频
            // type-上传类型，video：视频，audio:音频，img：图片
            let type = "video";
            let formData = new FormData();
            formData.append('file', fileListItem);
            formData.append('type', type);
            self.singleUploadFile(formData, type, progressHandler, completeHandler, sync);
        } else {
            // 七牛上传视频
            let fileName = fileListItem.name;
            let fileType = 1;
            var tokenParams = {
                source: 2,
                enterpriseCode: process.env.VUE_APP_NODE_CODE,
                type: 1, //1为视频，2为音频
                fileName: fileName,
            };
            let url = uploadUrls.getVideoUploadToken + "?datetimeflag=" + new Date().getTime();
            self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
        }
    },
    // 上传音频
    fetchUploadAudio(fileListItem, progressHandler, completeHandler, sync = true) {
        var self = this;
        if (self.uploadMethod == 2) {
            // 私有云上传音频
            // type-上传类型，video：视频，audio:音频，img：图片
            let type = "audio";
            let formData = new FormData();
            formData.append('file', fileListItem);
            formData.append('type', type);
            self.singleUploadFile(formData, type, progressHandler, completeHandler, sync);
        } else {
            // 七牛上传音频
            let fileName = fileListItem.name;
            let fileType = 1;
            var tokenParams = {
                source: 2,
                enterpriseCode: process.env.VUE_APP_NODE_CODE,
                type: 2, //1为视频，2为音频
                fileName: fileName,
            };
            let url = uploadUrls.getVideoUploadToken + "?datetimeflag=" + new Date().getTime();
            self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
        }
    },
    // 私有化本地上传
    singleUploadFile(formData, type, progressHandler, completeHandler, sync) {
        var self = this;

        self.uploadFileRequest(formData, function (event) {
            let percentage = parseInt(event.loaded / event.total * 100) + "%";
            progressHandler(percentage);
        }).then((res) => {
            if (res.code === '200') {
                if (sync) {
                    if (type == "img") {
                        // 上传图片后保存图片库
                        self.saveUploadPicture(res.data).then((r) => {
                            completeHandler({
                                suc: 1,
                                resourceId: r.data.resourceId,
                                url: r.data.url,
                            });
                        }).catch((err) => {
                            console.log("图片保存失败！\n" + err.message);
                        });
                    } else {
                        let data = res.data;
                        let params = [];

                        let streamsArr = data.transcodeConfigInfo.streams;
                        let userInfo = JSON.parse(window.localStorage.getItem('fz-share-userInfo'));

                        streamsArr.forEach(element => {
                            params.push({
                                "absoluteFullPath": data.absoluteFullPath,
                                "accessUrl": element.transcodeFileUrl,
                                "aspectRatio": '',
                                "audioEncoder": data.audioEncoder,
                                "audioTrack": "",
                                "bitStreamName": element.transcodeName,
                                "categoryId": self.categoryId,
                                "classifyType": self.isShare == 1 ? 1 : 2,
                                "creationStreamId": 0,
                                "editorName": '',
                                "code": userInfo.tenantCode,
                                "fileName": data.fileName,
                                "fileSize": data.fileSize,
                                "flieLayout": "",
                                "frameRate": 0,
                                "isShare": self.isShare,
                                "nodeUserId": userInfo.id,
                                "originalFilename": data.originalFilename,
                                "picAccessUrl": data.posterUrls && data.posterUrls.length ? data.posterUrls[0] : '',
                                "picKey": '',
                                "resourceAudioBps": 0,
                                "resourceLength": data.duration,
                                "resourceVideoBps": data.bitRate,
                                "samplingRate": data.samplingRate,
                                "snapshotId": 0,
                                "source": 1,
                                "sourceAccessUrl": data.fileUrl,
                                "sourceContentId": 0,
                                "sourceTitle": "",
                                "streamType": "",
                                "transcodeStatus": 1,
                                "type": type == 'video' ? 1 : 2,
                                "videoEncoder": data.videoEncoder,
                                "videoHeight": data.height,
                                "videoWidth": data.width,
                                "key": element.key,
                            });
                        });

                        // 批量保存
                        self.saveUploadStreamButch(JSON.stringify(params)).then((res) => {
                            if (typeof (res) === 'string') {
                                res = JSON.parse(res)
                            }
                            if (res.suc == 1) {
                                completeHandler({
                                    suc: 1,
                                    resourceId: res.data.streamIds[0],
                                    url: data.fileUrl,
                                    coverUrl: data.posterUrls ? data.posterUrls[0] : null
                                });
                            } else {
                                console.log(res.message);
                            }
                        });

                        // 单个保存
                        /* self.saveUploadStream(JSON.stringify(params[0])).then((res) => {
                            if (typeof (res) === 'string') {
                                res = JSON.parse(res)
                            }
                            if (res.suc == 1) {
                                completeHandler({
                                    suc: 1,
                                    resourceId: res.data.streamId,
                                    url: data.fileUrl,
                                    coverUrl: data.posterUrls ? data.posterUrls[0] : null
                                });
                            } else {
                                console.log(res.message);
                            }
                        }); */

                        self.transcodeFiles(data, type);
                    }
                } else {
                    completeHandler({
                        suc: 1,
                        resourceId: res.data.sourceid,
                        url: res.data.fileUrl,
                    });
                }
            } else {
                if (type == "img") {
                    console.log("私有化上传图片失败！\n" + res.message);
                } else if (type == "video") {
                    console.log("私有化上传视频失败！\n" + res.message);
                } else if (type == "audio") {
                    console.log("私有化上传音频失败！\n" + res.message);
                } else {
                    console.log("私有化上传文件失败！\n" + res.message);
                }
                completeHandler({
                    suc: 0,
                });
            }
        }).catch((err) => {
            if (type == "img") {
                console.log("私有化上传图片失败！");
            } else if (type == "video") {
                console.log("私有化上传视频失败！");
            } else if (type == "audio") {
                console.log("私有化上传音频失败！");
            } else {
                console.log("私有化上传文件失败！");
            }
        });
    },
    // 保存音视频后进行转码
    transcodeFiles(streamsData, fileType) {

        var self = this;

        let streams = streamsData.transcodeConfigInfo.streams;
        let streamArr = [];
        streams.forEach(function (val, idx) {
            streamArr.push({
                "stream_id": null,
                "fileName": val.fileName,
                "params": {
                    "format": val.params.format,
                    "videobitrate": val.params.videobitrate,  //视频比特率
                    "width": val.params.width,
                    "height": val.params.height,
                    "fps": val.params.fps,             //帧率，0使用源帧率
                    "audiobitrate": val.params.audiobitrate,      //音频比特率
                    "samplingrate": val.params.samplingrate,    //音频采样率
                    "channels": val.params.channels           //1单声道 2双声道
                }
            });
        });

        let destPath = streamsData.absoluteFullPath.replace(/\/([^\/])*$/, '');

        let params = {
            backurl: 'http://172.16.110.18:8080/Manage/business/transcodeCallback/transcodeCallback?version=4.0.3',
            code: streamsData.transcodeConfigInfo.code,
            taskid: streamsData.sourceid,  //源视频资源id,转码失败时，可重新转码", dataType = "Integer"
            dest_video: {
                type: "local",
                local: {
                    path: destPath,
                }
            },
            snapshotFileurl: streamsData.posterUrls && streamsData.posterUrls.length ? streamsData.posterUrls[0] : '',
            sourceAccessUrl: streamsData.fileUrl,
            src: {
                type: "local",
                local: {
                    path: streamsData.absoluteFullPath,
                }
            },
            streams: streamArr,
            whetherMaterial: self.tranFlag,  //业务-是否同步到资源库，回调时使用", dataType="Integer"
            fromContentType: 2,  //业务-来源位置 1富文本中，2单个视频文件3视频编辑，回调时使用", dataType = "Integer"
            domainId: null,  //业务-主表id,调用转码接口时传值,回调时使用", dataType = "Integer"
            fromType: null, //业务-来源 1创作中心、2分发中心、3媒体号，回调时使用", dataType = "Integer"
            fileType: fileType,  //转码类型video 视频，audio音频，回调时使用", dataType = "string"
            nodeUserId: streamsData.transcodeConfigInfo.nodeUserId,
        }

        self.transcode(JSON.stringify(params)); //音视频转码
    },
    // 停止上传
    stopUpload() {
        this.terminateUpload = true;
    },
    // 开始上传
    startUpload() {
        this.terminateUpload = false;
    },
}